import { useGame } from '../state/store'

// Fixed-timestep loop decoupled from render. Accumulates real elapsed time and
// advances the simulation in fixed steps so production is frame-rate independent.
const STEP_MS = 100 // 10 ticks/second

export function startGameLoop(): () => void {
  let raf = 0
  let last = performance.now()
  let acc = 0

  const frame = (now: number) => {
    acc += now - last
    last = now
    // Clamp to avoid a spiral of death after the tab was backgrounded.
    if (acc > 2000) acc = 2000
    const tick = useGame.getState().tick
    while (acc >= STEP_MS) {
      tick(STEP_MS / 1000)
      acc -= STEP_MS
    }
    raf = requestAnimationFrame(frame)
  }

  raf = requestAnimationFrame(frame)
  return () => cancelAnimationFrame(raf)
}
